import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function CTASection() {
  return (
    <section className="py-24 md:py-32 bg-black border-t border-[#D4AF37]/20">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center space-y-8">
        <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
          Ready to <span className="text-[#D4AF37]">Get Started?</span>
        </h2>
        <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
          Let's talk about your real estate goals. No pressure, just a real
          conversation about how I can help you win.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <a href="tel:+19092335411">
            <Button
              className="bg-[#D4AF37] text-black hover:bg-[#F3E5AB] rounded-none font-bold uppercase tracking-widest px-8 py-6 text-lg"
              data-testid="cta-call-button"
            >
              Call 909.233.5411
            </Button>
          </a>
          <Link to="/contact">
            <Button
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-black rounded-none font-bold uppercase tracking-widest px-8 py-6 text-lg"
              data-testid="cta-contact-button"
            >
              Send Message
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
